var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPipe1Ar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 603,
    height: 219,
    viewBox: "0 0 603 219",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M580 4L580 26.2294C580 43.9025 565.673 58.2294 548 58.2294L55 58.2294C37.3269 58.2294 23 72.5563 23 90.2294L23 219",
    stroke: "url(#paint0_linear_3_12)",
    strokeWidth: 45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279 58.4815L295.797 39.0119L295.797 77.9511L279 58.4815Z",
    fill: "url(#paint1_linear_3_12)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M292.802 58.5001L309.6 39.0305L309.6 77.9696L292.802 58.5001Z",
    fill: "url(#paint2_linear_3_12)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M306.604 58.5186L323.401 39.0491L323.401 77.9882L306.604 58.5186Z",
    fill: "url(#paint3_linear_3_12)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M579.482 50L560.012 33.2027L598.951 33.2027L579.482 50Z",
    fill: "url(#paint4_linear_3_12)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M579.5 36.1978L560.031 19.4005L598.97 19.4005L579.5 36.1978Z",
    fill: "url(#paint5_linear_3_12)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M579.519 22.3965L560.049 5.59923L598.988 5.59922L579.519 22.3965Z",
    fill: "url(#paint6_linear_3_12)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_12",
    x1: 0.727866,
    y1: 220.5,
    x2: 4.37016,
    y2: -80.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A0D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76337,
    stopColor: "#70A0D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_12",
    x1: 279,
    y1: 58.4815,
    x2: 301.396,
    y2: 58.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_12",
    x1: 292.802,
    y1: 58.5001,
    x2: 315.199,
    y2: 58.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_12",
    x1: 306.604,
    y1: 58.5186,
    x2: 329,
    y2: 58.5186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_12",
    x1: 579.482,
    y1: 50,
    x2: 579.482,
    y2: 27.6037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_12",
    x1: 579.5,
    y1: 36.1978,
    x2: 579.5,
    y2: 13.8014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_12",
    x1: 579.519,
    y1: 22.3965,
    x2: 579.519,
    y2: 0.00013759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipe1Ar);
export default __webpack_public_path__ + "static/media/pipe-1-ar.2501ec03187d1826c09fbfe7874286fb.svg";
export { ForwardRef as ReactComponent };